export const SCHIBSTED_ACCOUNT_START = 'SCHIBSTED_ACCOUNT_START';
export const SCHIBSTED_ACCOUNT_INIT = 'SCHIBSTED_ACCOUNT_INIT';
export const SCHIBSTED_ACCOUNT_INIT_COMPLETE = 'SCHIBSTED_ACCOUNT_INIT_COMPLETE';
export const SCHIBSTED_ACCOUNT_HAS_SESSION = 'SCHIBSTED_ACCOUNT_HAS_SESSION';
export const SCHIBSTED_ACCOUNT_HAS_SESSION_COMPLETE = 'SCHIBSTED_ACCOUNT_HAS_SESSION_COMPLETE';
export const SCHIBSTED_ACCOUNT_HAS_SESSION_ERROR = 'SCHIBSTED_ACCOUNT_HAS_SESSION_ERROR';
export const SCHIBSTED_ACCOUNT_LOGOUT = 'SCHIBSTED_ACCOUNT_LOGOUT';
export const SCHIBSTED_ACCOUNT_LOGIN = 'SCHIBSTED_ACCOUNT_LOGIN';
export const SCHIBSTED_ACCOUNT_GENERATE_URLS = 'SCHIBSTED_ACCOUNT_GENERATE_URLS';
export const SCHIBSTED_ACCOUNT_SUBSCRIBE_EVENTS = 'SCHIBSTED_ACCOUNT_SUBSCRIBE_EVENTS';

export const SCHIBSTED_ACCOUNT_EVENT_NOTLOGGEDIN = 'SCHIBSTED_ACCOUNT_EVENT_NOTLOGGEDIN';
export const SCHIBSTED_ACCOUNT_EVENT_STATUS_CHANGE = 'SCHIBSTED_ACCOUNT_EVENT_STATUS_CHANGE';
export const SCHIBSTED_ACCOUNT_EVENT_LOGIN = 'SCHIBSTED_ACCOUNT_EVENT_LOGIN';
export const SCHIBSTED_ACCOUNT_EVENT_LOGOUT = 'SCHIBSTED_ACCOUNT_EVENT_LOGOUT';
export const SCHIBSTED_ACCOUNT_EVENT_USER_CHANGE = 'SCHIBSTED_ACCOUNT_EVENT_USER_CHANGE';
export const SCHIBSTED_ACCOUNT_EVENT_SESSION_INIT = 'SCHIBSTED_ACCOUNT_EVENT_SESSION_INIT';
export const SCHIBSTED_ACCOUNT_EVENT_SESSION_CHANGE = 'SCHIBSTED_ACCOUNT_EVENT_SESSION_CHANGE';
export const SCHIBSTED_ACCOUNT_EVENT_VISITOR = 'SCHIBSTED_ACCOUNT_EVENT_VISITOR';
export const SCHIBSTED_ACCOUNT_EVENT_SESSION_ERROR = 'SCHIBSTED_ACCOUNT_EVENT_SESSION_ERROR';
